import React from 'react'

import { Show } from '@app/components/util'
import { LntEmpty, LntSpin, LntTree } from '@app/components/base'

import { isEmptyArray, isNullable } from '@app/utils'
import { presentedEmptyImage } from '@app/components/base/Empty/constants'

import { productHierarchyAdapter } from './utils'

import styles from './styles.module.scss'

import type { LntEventDataNode } from '@app/components/base/Tree/types'
import type { ProductHierarchyTreeData, ProductHierarchyTableSidebarProps } from './types'

export const ProductHierarchyTableSidebar: React.FC<ProductHierarchyTableSidebarProps> = ({
  isLoading,
  productHierarchyData,
  onSelect
}) => {
  const handleSelect = (_: unknown, { node }: { node: LntEventDataNode<ProductHierarchyTreeData> }): void => {
    const newSelectedNode = node.selected ? null : node

    onSelect?.(newSelectedNode)
  }

  return (
    <div className={ styles.productHierarchyTableSidebar }>
      <span className={ styles.productHierarchyTableSidebar__title }>Иерархия групп</span>

      <div className={ styles.productHierarchyTableSidebar__treeSlot }>
        <div className={ styles.productHierarchyTableSidebar__treeWrapper }>
          <LntSpin spinning={ isLoading }>
            <Show
              condition={ !isEmptyArray(productHierarchyData) && !isNullable(productHierarchyData) }
              fallback={ <LntEmpty image={ presentedEmptyImage.SIMPLE } /> }
            >
              <LntTree
                treeData={ productHierarchyAdapter(productHierarchyData) }
                onSelect={ handleSelect }
              />
            </Show>
          </LntSpin>
        </div>
      </div>
    </div>
  )
}
